// extracted by mini-css-extract-plugin
export default {"container":"Message_container__a8kqk","timer":"Message_timer__yNGyB","scaleDown":"Message_scaleDown__m9X7O"};